<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table custom-table-padding">
                <thead>
                    <tr>
                        <th>A-Challan Create Date</th>
                        <th>Number</th>
                        <th>TDS Section</th>
                        <th>VDS Section</th>
                        <th>Accounting head(s)</th>
                        <th>Challan No.</th>
                        <th>Challan Date</th>
                        <th>Bank-Branch</th>
                        <th>Amount</th>
                        <th>Attachment</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in tableItems" :key="item.id">
                        <td>{{ formatDate(new Date(item.created_at)) }}</td>
                        <td>{{ item.id }}</td>
                        <td>{{ item.tds_section_ref }}</td>
                        <td>{{ item.vds_section_ref }}</td>
                        <td>{{ item.account_head_name }}</td>
                        <td>{{ item.challan_no }}</td>
                        <td>{{ item.challan_date }}</td>
                        <td>{{ item.dealer_name }}</td>
                        <td class="text-right">{{ commaFormat(item.amount) }}</td>
                        <td></td>
                        <td>
                            <div class="action">
                                <button @click="editChallan(item)" class="btn btn-primary btn-sm">
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
</div>
</template>

<script setup>
import { formatDate } from '@/services/utils/global.js'
import figureFormatter from '@/services/utils/figureFormatter';
import { useRoute, useRouter } from 'vue-router';

const { commaFormat } = figureFormatter();

const props = defineProps({
    tableItems: {
        type: Array,
        default: []
    }
})

const router = useRouter();
const route = useRoute();

const editChallan = (item) => {
    router.push({
        name: 'edit-challan-register',
        params: { ... route.params, challanId: item.id },
    });
}
</script>

<style scoped>
.custom-table-padding {
    width: 110%
}
</style>